export const quotations = {
  title: 'Árajánlatok',
  subtitle: 'Árajánlatok kezelése és áttekintése',
  new: 'Új árajánlat',
  export: 'Exportálás',
  noOffer: 'Nincs árajánlat',
  shared: 'A link másolva a vágólapra!',
  selected: 'elem kiválasztva',
  bulkDelete: 'Csoportos törlés',
  bulkDeleteTitle: 'Árajánlatok törlése',
  bulkDeleteMessage: 'Biztosan törölni szeretné a kiválasztott {{count}} árajánlatot?',
  bulkDeleteWarning: 'Ez a művelet nem visszavonható, és az összes kiválasztott árajánlatot törli.',
  generateContract: 'Szerződés generálása',
  viewDetails: 'Részletek megtekintése',
  preview: {
    status: 'Státusz',
    validUntil: 'Érvényes',
    subtotal: 'Részösszeg',
    totalWithVat: 'Végösszeg ÁFÁ-val',
    product: 'Termék',
    quantity: 'Mennyiség',
    unitPrice: 'Egységár',
    vat: 'ÁFA',
    total: 'Összesen',
    downloadPdf: 'PDF letöltése',
    created: 'Létrehozva'
  },
  duplicate: 'Másolat készítése',
  fields: {
    number: 'Azonosító',
    organization: 'Szervezet',
    customer: 'Ügyfél',
    status: 'Státusz',
    total: 'Összesen',
    validUntil: 'Érvényes',
    actions: 'Műveletek',
    items: 'Tételek',
    subtotal: 'Részösszeg',
    tax: 'ÁFA',
    grandTotal: 'Végösszeg',
    viewCount: 'Megtekintések száma',
    product: 'Termék',
    quantity: 'Mennyiség',
    unitPrice: 'Egységár',
    taxRate: 'ÁFA %',
    createdAt: 'Létrehozva',
    date: 'Dátum'
  },
  status: {
    draft: 'Vázlat',
    editing: 'Szerkesztés alatt',
    pending: 'Függőben',
    rejected: 'Elutasítva',
    success: 'Elfogadva',
    accepted: 'Elfogadva',
    sent: 'Elküldve'
  },
  filter: {
    allStatuses: 'Összes státusz',
    allOrgs: 'Összes szervezet'
  },
  tooltips: {
    edit: 'Szerkesztés',
    delete: 'Törlés',
    preview: 'Előnézet',
    duplicate: 'Másolat készítése',
    download: 'Letöltés PDF',
    share: 'Megosztás',
    export: 'Exportálás',
    viewDetails: 'Részletes nézet',
    generateDocument: 'Dokumentum generálása',
    viewDocuments: 'Dokumentumok megtekintése',
    createContract: 'Szerződés létrehozása ajánlatból',
  },
  viewCount: '{{count}} megtekintés',
  shareModal: {
    title: 'Dokumentum megosztása',
    noDocuments: 'Nincs elérhető dokumentum',
    fileViewer: 'Kattintson a fájl megnyitásához',
    open: 'Megnyitás',
    openFile: 'Fájl megnyitása',
    linkCreated: 'Link létrehozva',
    lastViewed: 'Utoljára megnyitva',
    passwordProtection: 'Jelszóvédelem',
    password: 'Jelszó',
    validUntil: 'Érvényesség',
    updateLink: 'Link frissítése',
    createLink: 'Link létrehozása',
  },
  messages: {
    confirmTitle: 'Árajánlat törlése',
    deleteQuestion: 'Biztosan törölni szeretné ezt az árajánlatot?',
    deleteWarning: 'Ez a művelet nem visszavonható.',
    deleted: 'Árajánlat sikeresen törölve',
    deleteError: 'Hiba történt az árajánlat törlése közben',
    bulkDeleted: '{{count}} árajánlat sikeresen törölve',
    downloadError: 'Hiba történt a PDF letöltése közben',
    noDocuments: 'Nincs feltöltött dokumentum'
  },
  noData: 'Nincsenek árajánlatok',
  form: {
    basicDetails: {
      title: 'Árajánlat adatai',
    },
    title: {
      new: 'Új árajánlat létrehozása',
      edit: 'Árajánlat szerkesztése',
      create: 'Új árajánlat létrehozása'
    },
    productSearch: {
      title: 'Termék keresése',
      placeholder: 'Keresés termék név, kód vagy leírás alapján...',
      noResults: 'Nincs találat a keresési feltételeknek megfelelően',
      noProducts: 'Nincsenek elérhető termékek'
    },
    sections: {
      basic: {
        title: 'Alapinformációk'
      },
      items: {
        title: 'Tételek',
        item: 'Tétel',
        empty: 'Nincsenek tételek hozzáadva'
      },
      summary: 'Összesítés',
      companyDetails: {
        title: 'Cég adatai',
        quotationNumber: 'Árajánlat száma',
        companyName: 'Cég megnevezése',
        companyAddress: 'Cég címe',
        taxNumber: 'Cég adószáma',
        registrationNumber: 'Cégjegyzékszám',
      },
      contactAndPricing: {
        title: 'Kapcsolattartó és árazás',
        contactName: 'Kapcsolattartó neve',
        date: 'Dátum',
        paymentDue: 'Fizetési határidő (nap)',
        priceUnit: 'Ajánlati ár HUF/kWh-EUR/MWh',
        validUntil: 'Ajánlat érvényessége',
        price: 'Ajánlati ár',
        paymentDuePlaceholder: 'Adja meg a fizetési határidőt napokban',
      },
      consumptionAndContract: {
        title: 'Fogyasztás és szerződés',
        consumption: 'Fogyasztás kWh',
        contractStart: 'Szerződés kezdete',
        contractEnd: 'Szerződés vége',
        estimatedCost: 'Becsült áramköltség',
        price: "Ajánlati ár",
        estimatedAllCost: 'Becsült összköltség',
        noData: 'Az áramköltség kiszámításához hiányoznak adatok.',
      },
      kat: {
        title: 'KÁT',
        text: 'KÁT szöveg',
      },
      pod: {
        title: 'POD',
        podId: 'POD ',
        podAddress: 'Fogy.hely cím',
        measurementType: 'Távmérték / Profilos',
        power: 'Teljesítmény (kW)',
        profileNumber: 'Profil- szám',
        annualConsumption: 'MÉF / Éves mennyiség (kWh)',
      },
      additionalPods: {
        title: 'További POD-k',
        podId: 'POD {{index}}',
        podAddress: 'Fogy.hely cím {{index}}',
        measurementType: 'Távmérték / Profilos {{index}}',
        power: 'Teljesítmény (kW) {{index}}',
        profileNumber: 'Profil szám {{index}}',
        annualConsumption: 'MÉF {{index}} / Éves mennyiség (kWh)',
      },
      documents: {
        title: 'Dokumentumok',
        typeContract: 'Szerződés',
        typeQuotation: 'Árajánlat',
        typeOther: 'Egyéb',
      },
      notes: {
        title: 'Megjegyzések'
      }
    },
    fields: {
      organization: 'Szervezet',
      customer: 'Ügyfél',
      validUntil: 'Érvényesség',
      status: 'Státusz',
      product: 'Termék',
      quantity: 'Mennyiség',
      price: 'Egységár',
      tax: '% ÁFA',
      total: 'Összesen',
      notes: 'Megjegyzések',
      contactPerson: 'Kapcsolattartó',
      itemNotes: 'Tétel megjegyzés',
      quotationNotes: 'Árajánlat megjegyzés',
      listPrice: 'Listaár',
      date: 'Dátum'
    },
    buttons: {
      addItem: 'Tétel hozzáadása',
      removeItem: 'Tétel törlése',
      createOffer: 'Árajánlat létrehozása',
      updateOffer: 'Árajánlat frissítése',
      cancel: 'Mégse',
      uploadDocument: 'Dokumentum feltöltése',
      viewDocument: 'Megtekintés',
      deleteDocument: 'Törlés',
      createNewCustomer: 'Új ügyfél létrehozása'
    },
    messages: {
      noDocuments: 'Nincs feltöltött dokumentum'
    },
    validation: {
      organizationRequired: 'Szervezet megadása kötelező',
      customerRequired: 'Ügyfél megadása kötelező',
      validUntilRequired: 'Érvényességi dátum megadása kötelező',
      productRequired: 'Termék megadása kötelező',
      quantityRequired: 'Mennyiség megadása kötelező',
      priceRequired: 'Ár megadása kötelező',
      taxRequired: 'ÁFA mérték megadása kötelező',
      itemsRequired: 'Legalább egy tétel megadása kötelező'
    }
  },
  notes: {
    title: 'Megjegyzések'
  }
};